module.exports = __webpack_public_path__ + "img/icon-facebook.326c4594.png";